import { ComboDto } from "./ComboDto";
import { MessageDto } from "./MessageDto";
import { ProductDto } from "./ProductDto";
import { PromotionProductDto } from "./PromotionProductDto";

/**
 * Method object
 */
export class PromotionDto {
  id: number;
  code: string;
  name: string;
  startDate: Date;
  endDate: Date;
  startTime: Date;
  endTime: Date;
  percentDiscount?: number;
  amountDiscount?: number;
  promotionType: number;
  promotionCategory: number;

  isTimeFrame: boolean;
  isLoseMessage: boolean;
  isWinMessage: boolean;
  isOnScreenMessage: boolean;
  isApplyMessage: boolean;

  messages: Array<MessageDto>;
  timeFrames: string;
  promotionRatio: string;
  increaseRatio: string;
  promotionLimit: string;
  machineLimit: string;
  limitType: string;

  isApplyAllProduct: boolean;
  products: Array<PromotionProductDto>;
  comboes: Array<ComboDto>;

  idCombo: number;
  nameCombo: string;
  priceComboNew: number;
  priceComboOld: number;
  imageCombo: string;

  // 
  productForCombos: Array<ProductDto>;

  idProductGift: number;
  codeProductGift: string;
  nameProductGift: string;
  brandIdProductGift: number;
  weightIncludePackaging: number;
  imageProductGift: string;
  categoryProductGift: string;
  sellingPriceProductGift: number;
  quanlityProductGift: number; // SL tặng
  quantityProductGift: number; // SL tồn
  minBuyQuanlityGift: number;

  giftType: string;

  gameCode: string;
  gameName: string;
  gameLink: string;
  gameScope: string;
  gamePolicyId: number;
  timeCreate: Date;

  // UTOP
  aPILink: string;
  isIntergatePartner: boolean;
  samlinngType: string;
  expiredDateCombo?: Date;
  isSoldOutCombo?: boolean = false;
  isExpiredCombo?: boolean = false;
  qtyCombo?: number;
  // Voucher
  maxBuyQuantity: number;

  roundingPrinciple: string;
  roundingValue: number;
  isRequestUserInfo: boolean = false;
  termsAndConditions: string;
  isDiscountByExpirationDate: boolean = false;
  discountByExpirationDateValue: number;
  isShowIcon: boolean = false;

  operationType: string;
  operationId: number;

  productOwnerType: string;
  productOwnerId: number;

  partyPayFee: string;
  partnerId: number;

  operationByDateList: Array<any>;
}